import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "/api";

const api = axios.create({ baseURL: BASE_URL });

// Attach access token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-refresh the access token on 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      const refresh = localStorage.getItem("refresh_token");
      if (refresh) {
        try {
          const { data } = await axios.post(`${BASE_URL}/auth/token/refresh/`, { refresh });
          localStorage.setItem("access_token", data.access);
          original.headers.Authorization = `Bearer ${data.access}`;
          return api(original);
        } catch (err) {
          localStorage.clear();
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

// ---------- Auth ----------
export const registerUser = (payload) => api.post("/auth/register/", payload);
export const loginUser = (payload) => api.post("/auth/login/", payload);
export const getProfile = () => api.get("/auth/profile/");
export const changePassword = (payload) => api.post("/auth/change-password/", payload);
// [FORGOT-PASSWORD FEATURE - DEMO] remove this line to roll back
export const forgotPassword = (payload) => api.post("/auth/forgot-password/", payload);

// ---------- QR Codes ----------
export const listQRCodes = (params) => api.get("/qrcodes/", { params });
export const getQRCode = (id) => api.get(`/qrcodes/${id}/`);
export const createQRCode = (formData) =>
  api.post("/qrcodes/", formData, { headers: { "Content-Type": "multipart/form-data" } });
export const updateQRCode = (id, formData) =>
  api.put(`/qrcodes/${id}/`, formData, { headers: { "Content-Type": "multipart/form-data" } });
export const deleteQRCode = (id) => api.delete(`/qrcodes/${id}/`);
export const regenerateQRCode = (id) => api.post(`/qrcodes/${id}/regenerate/`);
export const toggleQRCodeActive = (id) => api.post(`/qrcodes/${id}/toggle_active/`);

// ---------- Analytics ----------
export const getAnalyticsSummary = (params) => api.get("/analytics/summary/", { params });
export const getScanGraph = (params) => api.get("/analytics/scans/", { params });

// ---------- Admin: Users ----------
export const adminListUsers = () => api.get("/auth/admin/users/");
export const adminGetUser = (id) => api.get(`/auth/admin/users/${id}/`);
export const adminCreateUser = (payload) => api.post("/auth/admin/users/", payload);
export const adminUpdateUser = (id, payload) => api.patch(`/auth/admin/users/${id}/`, payload);
export const adminDeleteUser = (id) => api.delete(`/auth/admin/users/${id}/`);
export const adminSetUserPassword = (id, password) =>
  api.post(`/auth/admin/users/${id}/set_password/`, { password });
export const adminSetUserRole = (id, role) =>
  api.post(`/auth/admin/users/${id}/set_role/`, { role });
export const adminToggleUserActive = (id) =>
  api.post(`/auth/admin/users/${id}/toggle_active/`);

export default api;
